<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'

import '@/assets/landing.css'
import { useLandingTheme } from '@/composables/useLandingTheme'

const { theme } = useLandingTheme()

onMounted(() => {
  document.documentElement.classList.add('landing-root')
})

onUnmounted(() => {
  document.documentElement.classList.remove('landing-root')
})
</script>

<template>
  <div class="landing min-h-full" :data-theme="theme">
    <slot />
  </div>
</template>
